import { ConductorStatistics } from "./onboardingLiveStatistics.ts";
import { formatDecimal, formatShare } from "./statisticsFormat.ts";

const headerCellClassName =
  "px-3 md:px-6 py-3 text-left bg-gray-50 uppercase text-gray-700";
const cellClassName = "px-3 md:px-6 py-3";

export function OnboardingLiveConductorsTable({
  conductors,
  teacherNameOf,
}: {
  conductors: ConductorStatistics[];
  teacherNameOf: (teacherId: string) => string;
}) {
  if (conductors.length <= 0)
    return (
      <p className={"text-sm text-slate-500"}>
        Nessuna live svolta nel periodo.
      </p>
    );

  return (
    <div className={"overflow-x-auto"}>
      <table className={"w-full min-w-[640px] text-sm"}>
        <thead>
          <tr>
            <th className={headerCellClassName}>Conduttore</th>
            <th className={headerCellClassName}>Live condotte</th>
            <th className={headerCellClassName}>Iscritti medi</th>
            <th className={headerCellClassName}>Partecipanti medi</th>
            <th className={headerCellClassName}>Feedback inviati</th>
            <th className={headerCellClassName}>Sostituito</th>
          </tr>
        </thead>
        <tbody>
          {conductors.map((conductor) => (
            <tr
              key={conductor.teacherId}
              className={"border-b border-gray-100 last:border-b-0"}
            >
              <td className={`${cellClassName} font-medium`}>
                {teacherNameOf(conductor.teacherId)}
              </td>
              <td className={cellClassName}>{conductor.lives}</td>
              <td className={cellClassName}>
                {formatDecimal(conductor.averageEnrolled)}
              </td>
              <td className={cellClassName}>
                {formatDecimal(conductor.averageAttended)}
              </td>
              <td className={cellClassName}>
                {formatShare(conductor.feedbackShare)}
              </td>
              <td className={cellClassName}>
                {conductor.timesReplaced > 0
                  ? `${conductor.timesReplaced} ${conductor.timesReplaced === 1 ? "volta" : "volte"}`
                  : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
